<template>
	<svg width="24" height="24" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M1.625 5.48425C1.625 5.03552 1.98877 4.67175 2.4375 4.67175H10.5625C11.0112 4.67175 11.375 5.03552 11.375 5.48425V11.1718C11.375 11.6205 11.0112 11.9843 10.5625 11.9843H2.4375C1.98877 11.9843 1.625 11.6205 1.625 11.1718V5.48425ZM10.5625 5.48425H2.4375V11.1718H10.5625V5.48425Z"
			:fill="color"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.5 1.828C6.1229 1.828 5.76124 1.97781 5.49458 2.24446C5.22793 2.51111 5.07813 2.87277 5.07813 3.24988V5.078C5.07813 5.30237 4.89624 5.48425 4.67188 5.48425C4.44751 5.48425 4.26562 5.30237 4.26562 5.078V3.24988C4.26562 2.65728 4.50103 2.08896 4.92006 1.66994C5.33909 1.25091 5.90741 1.0155 6.5 1.0155C7.09259 1.0155 7.66091 1.25091 8.07994 1.66994C8.49897 2.08896 8.73438 2.65728 8.73438 3.24988V5.078C8.73438 5.30237 8.55249 5.48425 8.32813 5.48425C8.10376 5.48425 7.92188 5.30237 7.92188 5.078V3.24988C7.92188 2.87277 7.77207 2.51111 7.50542 2.24446C7.23876 1.97781 6.8771 1.828 6.5 1.828Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		color: {
			default: '#597393',
		},
	},
};
</script>
